export default __webpack_public_path__ + "static/media/ticket-counter.0bd55086.jpg";